import { render, staticRenderFns } from "./EntityNameInfo.vue?vue&type=template&id=25b0a732&"
import script from "./EntityNameInfo.vue?vue&type=script&lang=js&"
export * from "./EntityNameInfo.vue?vue&type=script&lang=js&"
import style0 from "./EntityNameInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports